import React, { FC } from 'react';
import './newLabel.module.scss';

export const NewLabel: FC = () => {
  return <div styleName="label">NEW</div>;
};
